export default __webpack_public_path__ + "static/media/9.104d72d3.webp";